import Vue from 'vue';
import Vuex, {ActionContext, Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {DateFilter, NumberFilter} from '@/shared/filter';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState, PaginatorMutation,
	PaginatorMutationFilter,
	StandardAction
} from '@/shared/utils';
import {Approvisionnement, BoisType, Fournisseur, LongueursVente, Pile} from '@/models';
import store from '@/stores';
import {ApprovisionnementService} from "@/xhttp";

Vue.use(Vuex);

export class ApprovisionnementFilter {

	date: DateFilter = new DateFilter();
	boisType: BoisType[] = [];
	longueursVente: LongueursVente[] = [];
	fournisseur: Fournisseur[] = [];
	pile: Pile[] = [];
	numberCoupe: string = '';
	location: string = '';
	volume: string = '';
	totalParBoisType: boolean = false;
	totalParLongueur: boolean = false;
	totalDateDebut: string = '';
	totalDateFin: string = '';

	public clear(): void {
		this.date = new DateFilter();
		this.boisType = [];
		this.longueursVente = [];
		this.fournisseur = [];
		this.pile = [];
		this.numberCoupe = '';
		this.location = '';
		this.volume = '';
		this.totalParBoisType = false;
		this.totalParLongueur = false;
		this.totalDateDebut = '';
		this.totalDateFin = '';
	}

	public toString(): string {
		return JSON.stringify({
			date	: this.date,
			boisType    : this.boisType.map(t => t.id),
			longueursVente    : this.longueursVente.map(t => t.id),
			fournisseur    : this.fournisseur.map(t => t.id),
			pile    : this.pile.map(t => t.id),
			numberCoupe: this.numberCoupe,
			location : this.location,
			volume : this.volume,
			totalParBoisType	: this.totalParBoisType,
			totalParLongueur	: this.totalParLongueur,
			totalDateDebut	:	this.totalDateDebut,
			totalDateFin	:	this.totalDateFin,
		});
	}
}

class ApprovisionnementState extends PaginatorFilterState<ApprovisionnementFilter> {
	public approvisionnement: Approvisionnement = null;
	public approvisionnements: ResultType<Approvisionnement> = null;
	public constructor() {
		super(new ApprovisionnementFilter(), 'approvisionnements', 'approvisionnement', 'date', AscDesc.DESC, 50);
	}
}


class ApprovisionnementStore {

	@XHTTPService(() => Approvisionnement)
	private approvisionnementService: ApprovisionnementService;
	private  _store: Store<any>;

	public state: ApprovisionnementState = new ApprovisionnementState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'approvisionnements', 'approvisionnement'),
	};

	public actions = {
		...StandardAction<Approvisionnement, ApprovisionnementState>(() => Approvisionnement, 'approvisionnement'),
		...PaginatorActionWithFilters<Approvisionnement, ApprovisionnementState>(() => Approvisionnement, 'approvisionnements', 'approvisionnement'),
		

		async getTotauxApprovisionnements(context: ActionContext<ApprovisionnementState, any>): Promise<ResultType<Approvisionnement>> {
			const approvisionnementsTotauxResult = await instance.approvisionnementService.getTotauxApprovisionnements(storeApprovisionnementsTotaux.state.filters.totalParBoisType, storeApprovisionnementsTotaux.state.filters.totalParLongueur, storeApprovisionnementsTotaux.state.filters.totalDateDebut, storeApprovisionnementsTotaux.state.filters.totalDateFin);
			context.commit('setApprovisionnements', approvisionnementsTotauxResult);
			return approvisionnementsTotauxResult;
		},
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new ApprovisionnementStore();
const storeApprovisionnement = new Vuex.Store(instance);
instance.init(storeApprovisionnement);

const instanceTotaux = new ApprovisionnementStore();
export const storeApprovisionnementsTotaux = new Vuex.Store(instanceTotaux);
instanceTotaux.init(storeApprovisionnementsTotaux);

store.registerModule('approvisionnement', storeApprovisionnement);
store.registerModule('approvisionnementsTotaux', storeApprovisionnementsTotaux);
export default storeApprovisionnement;
